'use client';

import { IconStatisticsNumbers } from '@/features/icons';
import TabBar from '@/features/tab-bar/tab-bar';
import { TabSize } from '@/features/tab-bar/types';
import EcommerceStatistics from './ecommerce';
import HumanStatistics from './human';
import ProcessingStatistics from './processing';
import SocialStatistics from './social';
import './style.css';
import TeamStatistics from './team';
import { useLanguage } from '../../context/language-context-provider';
import SectionHeading from '../section-heading';
const KhanoumiStatistics = () => {
  const {
    t
  } = useLanguage();
  const ITEMS = [{
    header: t('statistics.ecommerce.title'),
    body: <EcommerceStatistics />
  }, {
    header: t('statistics.human.title'),
    body: <HumanStatistics />
  }, {
    header: t('statistics.processing.title'),
    body: <ProcessingStatistics />
  }, {
    header: t('statistics.social.title'),
    body: <SocialStatistics />
  }, {
    header: t('statistics.team.title'),
    body: <TeamStatistics />
  }];
  return <div id='statistics' className='homepage-container lg:mt-30' data-sentry-component="KhanoumiStatistics" data-sentry-source-file="index.tsx">
            <div className='relative flex flex-col items-center gap-7 lg:gap-18 lg:pt-33'>
                <SectionHeading icon={<IconStatisticsNumbers />} title={t('statistics.title')} className='lg:absolute lg:left-22 lg:top-0' data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
                    <span className='absolute -bottom-[68px] left-1/2 -z-10 hidden h-18 w-px bg-border-pink lg:inline-block' />
                </SectionHeading>

                <div className='w-full rounded bg-primary-main p-3 lg:rounded-xl lg:p-6'>
                    <TabBar items={ITEMS} size={TabSize.Medium} headClassName='max-w-full overflow-auto hide-scrollbar' bodyClassName='bg-white mt-3 lg:mt-6 rounded min-h-[356px] lg:min-h-fit' data-sentry-element="TabBar" data-sentry-source-file="index.tsx" />
                </div>
            </div>
        </div>;
};
export default KhanoumiStatistics;